import {createStateMaker} from '@shared/helpers/object'

import {ErrorState} from '../interfaces'

export const getInitialState = (): ErrorState => ({
    failureCase: {
        type: null,
        code: '',
        validationFailure: undefined,
    },
    exceptionCodeMap: {},
})

export const makeMock = createStateMaker<ErrorState>(getInitialState)
